<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4">
      <standard-table :after-search="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"
                      :before-pagination="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"
                      :customFields="[{ key: 'eventActiveIcon', label: this.$tc('message.notification', 1) }]"
                      :fields="operationFields"
                      :items="operationItems"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 6, xl: 6, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"
                      :row-before-search="{cols: 12,sm: 12,md: 12,lg: 2,xl: 2,order: 1,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"

                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :search-label-horizontal="false"
                      :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                      fullWidth="true"
                      noContainerPadding="true"
                      ref="operationTable"

                      @rowInfo="showInfo($event.item)"
                      @rowEdit="pushToEdit($event.item)"
                      @rowDelete="showInfo($event.item, true)">
        <div slot="eventActiveIcon" slot-scope="row">
          <div v-if="row.item.eventActiveVal">
            <font-awesome-icon icon="envelope"
                               class="c-green"
                               size="lg"
                               v-b-popover.hover.top="`${$tc('message.notification', 1)} ${$tc('message.enabled', 2).toLowerCase()}`"/>
          </div>

          <div v-else>
            <font-awesome-icon icon="envelope"
                               class="c-red"
                               size="lg"
                               v-b-popover.hover.top="`${$tc('message.notification', 1)} ${$tc('message.disabled', 2).toLowerCase()}`"/>
          </div>
        </div>

        <b-container class="mw-100 p-0" slot="row-before-search">
          <b-row align-h="end">
            <b-col class="mb-3" cols="12" lg="12" md="12" sm="12" xl="12">
              <!-- config[crud], create - read - update - delete -->
              <b-button class="b-c-blue float-right" id="add-operation"
                        v-if="config.c ? (vehicleFilter ? find(vehiclesOption, obj => obj.value === vehicleFilter).enabled : true) : false"
                        v-on:click="pushToEdit()">
                {{$t('message.add')}}
              </b-button>

              <h4 class="float-right c-green" v-if="vehicleFilter && !find(vehiclesOption, obj => obj.value === vehicleFilter).enabled">
                {{$tc('message.vehicle', 1)}} {{$tc('message.disabled', 0).toLowerCase()}}
              </h4>
            </b-col>
          </b-row>
        </b-container>

        <b-container class="mw-100 p-0 " slot="row-after-search">
          <b-row>
            <b-col cols="auto">
              <b-button class="b-c-green" id="reset-filters" v-on:click="resetFilters()">
                {{$t('message.resetFilters')}}
              </b-button>
            </b-col>

            <b-col class="mb-3" cols="auto">
              <b-button :class="showCollapse ? 'b-c-red' : 'b-c-green'" @click="showCollapse = !showCollapse" id="show-filters">
                <span class="when-opened" v-show="!showCollapse">{{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                <span class="when-closed" v-show="showCollapse">{{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container class="mw-100 p-0" slot="after-search">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" lg="3" md="6" sm="12" xl="3">
                  <b-form-group :label="`${$tc('message.vehicle', 1)}`"
                                label-for="input-vehicle">
                    <model-list-select :customText="getVehicleOption"
                                       :list="vehiclesOption"
                                       :placeholder="vehiclesOption && vehiclesOption.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       id="input-vehicle"
                                       option-text="text"
                                       option-value="value"
                                       v-model="vehicleFilter">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" lg="3" md="6" sm="12" xl="3">
                  <b-form-group :label="`${$tc('message.status', 1)} ${$tc('message.vehicle', 1).toLowerCase()}`"
                                label-for="status-vehicle">
                    <model-list-select :list="disabledOptions"
                                       :placeholder="disabledOptions && disabledOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       id="status-vehicle"
                                       option-text="text"
                                       option-value="value"
                                       v-model="disabledFilter">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" lg="3" md="6" sm="12" xl="3">
                  <b-form-group :label="`${$tc('message.type', 1)} ${$tc('message.operation', 1)}`"
                                label-for="input-special">
                    <model-list-select :list="operationType"
                                       :placeholder="operationType && operationType.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       id="input-special"
                                       option-text="text"
                                       option-value="value"
                                       v-model="operationTypeFilter">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" lg="3" md="6" sm="12" xl="3">
                  <b-form-group :label="`${$t('message.causal')}`"
                                label-for="input-causal">
                    <model-list-select :list="operationOptions"
                                       :placeholder="operationOptions && operationOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       id="input-causal"
                                       option-text="text"
                                       option-value="value"
                                       v-model="operationFilter">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" lg="3" md="6" sm="6" xl="3">
                  <b-form-group :label="`km ${$tc('message.from', 1).toLowerCase()}`">
                    <b-input-group append="km">
                      <b-form-input :placeholder="`${$tc('message.example', 1)}: 1500`"
                                    autocomplete="off"
                                    id="km-start"
                                    min="1"
                                    type="number"
                                    v-model="kmStart">
                      </b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" lg="3" md="6" sm="6" xl="3">
                  <b-form-group :label="`km ${$tc('message.to', 1).toLowerCase()}`">
                    <b-input-group append="km">
                      <b-form-input :placeholder="`${$tc('message.example', 1)}: 1500`"
                                    autocomplete="off"
                                    id="km-end"
                                    min="1"
                                    type="number"
                                    v-model="kmEnd">
                      </b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" lg="3" md="6" sm="12" xl="3">
                  <b-form-group :label="`${$tc('message.date', 1)} ${$tc('message.start', 1).toLowerCase()}`"
                                label-for="filter-start">
                    <b-input-group>
                      <flat-pickr :config="startFilterConfig"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  :readonly="false"
                                  @on-change="startFilterChanged"
                                  class="form-control"
                                  id="filter-start"
                                  v-model="startFilter">
                      </flat-pickr>
                      <div class="input-group-append">
                        <b-button :disabled="!startFilter"
                                  @click="startFilter = null">
                          <font-awesome-icon icon="trash"/>
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" lg="3" md="6" sm="12" xl="3">
                  <b-form-group :label="`${$tc('message.date', 1)} ${$tc('message.end', 1).toLowerCase()}`"
                                label-for="filter-end">
                    <b-input-group>
                      <flat-pickr :config="endFilterConfig"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  :readonly="false"
                                  @on-change="endFilterChanged"
                                  class="form-control"
                                  id="filter-end"
                                  v-model="endFilter">
                      </flat-pickr>
                      <div class="input-group-append">
                        <b-button :disabled="!endFilter"
                                  @click="endFilter = null">
                          <font-awesome-icon icon="trash"/>
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" lg="4" md="6" sm="12" xl="4">
                  <b-form-group :label="$tc('message.society', 1)"
                                label-for="input-corp">
                    <model-list-select :list="companyOptions"
                                       :placeholder="companyOptions && companyOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       id="input-corp"
                                       option-text="text"
                                       option-value="value"
                                       v-model="companyFilter">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" lg="4" md="6" sm="12" xl="4">
                  <b-form-group :label="`${$tc('message.sector', 1)} ${$tc('message.activity', 1).toLowerCase()}`"
                                label-for="input-activity-sector">
                    <model-list-select :list="activitySectorOptions"
                                       :placeholder="activitySectorOptions && activitySectorOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       id="input-activity-sector"
                                       option-text="text"
                                       option-value="value"
                                       v-model="activitySectorFilter">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" lg="4" md="6" sm="12" xl="4">
                  <b-form-group :label="`${$tc('message.property', 1)}`"
                                label-for="input-owner">
                    <model-list-select :list="ownerOptions"
                                       :placeholder="ownerOptions && ownerOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       id="input-owner"
                                       option-text="text"
                                       option-value="value"
                                       v-model="ownerFilter">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" lg="4" md="6" sm="12" xl="4">
                  <b-form-group :label="$tc('message.insuranceCompany', 1)"
                                label-for="input-insuranceCompany">
                    <model-list-select :list="insuranceCompanyOptions"
                                       :placeholder="insuranceCompanyOptions && insuranceCompanyOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       id="input-insuranceCompany"
                                       option-text="text"
                                       option-value="value"
                                       v-model="insuranceCompanyFilter">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" lg="4" md="6" sm="12" xl="4">
                  <b-form-group :label="`${$tc('message.notification', 1)}`"
                                label-for="input-notification">
                    <model-list-select :list="notificationOptions"
                                       :placeholder="notificationOptions && notificationOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       id="input-notification"
                                       option-text="text"
                                       option-value="value"
                                       v-model="notificationFilter">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" lg="4" md="6" sm="12" xl="4">
                  <b-form-group :label="$tc('message.done', 1)"
                                label-for="input-done">
                    <model-list-select :list="operationDone"
                                       :placeholder="operationDone && operationDone.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       id="input-done"
                                       option-text="text"
                                       option-value="value"
                                       v-model="doneFilter">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container class="mw-100 p-0" slot="before-pagination">
          <b-row align-v="center" class="mb-3">
            <b-col cols="12" lg="3" md="6" sm="6" xl="3">
              <font-awesome-icon icon="envelope"
                                 id="notification-green"
                                 class="c-green"
                                 size="lg"/>

              {{$tc('message.notification', 1)}} {{$tc('message.enabled', 3).toLowerCase()}}

              <b-popover placement="top" target="notification-green" triggers="hover">
                {{$tc('info.notificationEnabled')}}
              </b-popover>
            </b-col>

            <b-col cols="12" lg="3" md="6" sm="6" xl="3">
              <font-awesome-icon icon="envelope"
                                 id="notification-red"
                                 class="c-red"
                                 size="lg"/>
              {{$tc('message.notification', 1)}} {{$tc('message.disabled', 2).toLowerCase()}}

              <b-popover placement="top" target="notification-red" triggers="hover">
                {{$tc('info.notificationDisabled')}}
              </b-popover>
            </b-col>
          </b-row>
        </b-container>

        <b-container class="mw-100 p-0" slot="row-after-per-page">
          <b-row>
            <b-col>
              <b-button @click="$refs.operationTable.excel($tc('message.operation', 2), getExcelFields())" class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0" id="excel-button">Excel</b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>

      <b-modal :title="isDeleteMode ? `${$t('message.caution')}!` : $t('info.infoModal')" id="info-modal" ref="infoModal" size="lg">
        <b-container>
          <b-row>
            <b-col>
              <h5 class="c-red" v-if="isDeleteMode">{{$t('message.deleteCheck')}}:</h5>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" lg="4" md="4" sm="12" xl="4">
              <div class="d-flex">
                <h6><b>{{$tc('message.numberPlate', 1)}}:</b></h6>
                <h6 class="ml-2">{{infoItem.plateNumber}}</h6>
              </div>
            </b-col>

            <b-col cols="12" lg="4" md="4" sm="12" xl="4">
              <div class="d-flex">
                <h6><b>{{$tc('message.brand', 1)}}:</b></h6>
                <h6 class="ml-2">{{infoItem.brand || $tc('message.emptyValue', 1)}}</h6>
              </div>
            </b-col>

            <b-col cols="12" lg="4" md="4" sm="12" xl="4">
              <div class="d-flex">
                <h6><b>{{$tc('message.model', 1)}}:</b></h6>
                <h6 class="ml-2">{{infoItem.model || $tc('message.emptyValue', 1)}}</h6>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" lg="4" md="4" sm="12" xl="4">
              <div class="d-flex">
                <h6><b>{{$tc('message.society', 1)}}:</b></h6>
                <h6 class="ml-2">{{infoItem.userCompanyText || $tc('message.emptyValue', 1)}}</h6>
              </div>
            </b-col>

            <b-col cols="12" lg="4" md="4" sm="12" xl="4">
              <div class="d-flex">
                <h6><b>{{$tc('message.sector', 1)}} {{$tc('message.activity', 1).toLowerCase()}}:</b></h6>
                <h6 class="ml-2">{{infoItem.activitySectorText || $tc('message.emptyValue', 1)}}</h6>
              </div>
            </b-col>

            <b-col cols="12" lg="4" md="4" sm="12" xl="4">
              <div class="d-flex">
                <h6><b>{{$tc('message.property', 1)}}:</b></h6>
                <h6 class="ml-2">{{infoItem.ownerText || $tc('message.emptyValue', 1)}}</h6>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" lg="6" md="12" sm="12" xl="6">
              <div class="d-flex">
                <h6><b>{{$tc('message.type', 1)}}:</b></h6>
                <h6 class="ml-2">{{infoItem.specialDesc || $tc('message.emptyValue', 1)}}</h6>
              </div>
            </b-col>

            <b-col cols="12" lg="6" md="12" sm="12" xl="6">
              <div class="d-flex">
                <h6><b>{{$t('message.causal')}}:</b></h6>
                <h6 class="ml-2 overflow-hidden">{{infoItem.causalDesc || $tc('message.emptyValue', 1)}}</h6>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" lg="6" md="12" sm="12" xl="6">
              <b-container class="m-0 p-0 mw-100 w-100">
                <b-row>
                  <b-col cols="12" lg="8" md="8" sm="8" xl="8">
                    <h6><b>{{$tc('message.date', 1)}} {{$tc('message.operation', 1).toLowerCase()}} {{$t('message.scheduled').toLowerCase()}}:</b></h6>
                  </b-col>

                  <b-col>
                    <h6 v-if="infoItem.parsedPlannedDate">{{infoItem.parsedPlannedDate}}</h6>
                    <h6 v-else><b>- - - - - - - -</b></h6>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>

            <b-col cols="12" lg="6" md="12" sm="12" xl="6">
              <b-container class="m-0 p-0 mw-100 w-100">
                <b-row>
                  <b-col cols="12" lg="8" md="8" sm="8" xl="8">
                    <h6><b>km {{$tc('message.operation', 1).toLowerCase()}} {{$t('message.scheduled').toLowerCase()}}:</b></h6>
                  </b-col>

                  <b-col>
                    <h6 v-if="infoItem.plannedKm">{{infoItem.plannedKm}}</h6>
                    <h6 v-else><b>- - - - - - - -</b></h6>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" lg="6" md="12" sm="12" xl="6">
              <b-container class="m-0 p-0 mw-100 w-100">
                <b-row>
                  <b-col cols="12" lg="8" md="8" sm="8" xl="8">
                    <h6><b>{{$tc('message.date', 1)}} {{$tc('message.operation', 1).toLowerCase()}} {{$tc('message.done', 1).toLowerCase()}}:</b></h6>
                  </b-col>

                  <b-col>
                    <h6 v-if="infoItem.parsedExecDate">{{infoItem.parsedExecDate}}</h6>
                    <h6 v-else><b>- - - - - - - -</b></h6>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>

            <b-col cols="12" lg="6" md="12" sm="12" xl="6">
              <b-container class="m-0 p-0 mw-100 w-100">
                <b-row>
                  <b-col cols="12" lg="8" md="8" sm="8" xl="8">
                    <h6><b>km {{$tc('message.operation', 1).toLowerCase()}} {{$tc('message.done', 1).toLowerCase()}}:</b></h6>
                  </b-col>

                  <b-col>
                    <h6 v-if="infoItem.execKm">{{infoItem.execKm}}</h6>
                    <h6 v-else><b>- - - - - - - -</b></h6>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" lg="3" md="12" sm="12" xl="3">
              <div class="d-flex">
                <h6><b>{{$tc('message.done', 1)}}:</b></h6>
                <h6 class="ml-2"><b :class="`ml-2 ${infoItem.executed ? 'c-green' : 'c-red'}`">
                  {{infoItem.executedText}}
                </b></h6>
              </div>
            </b-col>

            <b-col cols="12" lg="4" md="12" sm="12" xl="4">
              <div class="d-flex">
                <h6><b>{{$tc('message.notification', 1)}}:</b></h6>
                <h6 class="ml-2">{{infoItem.eventActiveText || $tc('message.emptyValue', 1)}}</h6>
              </div>
            </b-col>

            <b-col cols="12" lg="6" md="12" sm="12" xl="6">
              <div class="d-flex">
                <h6><b>{{$tc('message.notificationGroup', 1)}}:</b></h6>
                <h6 class="ml-2">{{infoItem.notificationGroup || $tc('message.emptyValue', 1)}}</h6>
              </div>
            </b-col>

            <b-col cols="12" lg="6" md="12" sm="12" xl="6">
              <div class="d-flex">
                <h6><b>{{$tc('message.reminderGroup', 1)}}:</b></h6>
                <h6 class="ml-2">{{infoItem.reminderGroup || $tc('message.emptyValue', 1)}}</h6>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <div class="d-flex mt-2">
                <h6><b>{{$tc('message.note', 2)}}:</b></h6>
                <h6 class="ml-2" style="word-wrap: break-word; width: 83%;">{{infoItem.description || $tc('message.emptyValue', 1)}}</h6>
              </div>
            </b-col>
          </b-row>
        </b-container>

        <div class="w-100 justify-content-end d-flex" slot="modal-footer" v-if="!isDeleteMode">
          <b-button class="b-c-green mr-3" v-on:click="closeInfoModal()">Ok</b-button>
        </div>

        <div class="w-100 justify-content-end d-flex" slot="modal-footer" v-if="isDeleteMode">
          <b-button @click="closeInfoModal()" class="m-1 b-c-green" id="nw-delete-close">{{$t('message.cancel')}}</b-button>

          <b-button @click="checkSchedulingDelete(infoItem)" class="m-1 b-c-green" id="nw-delete-continue">{{$t('message.continue')}}</b-button>
        </div>
      </b-modal>
    </b-card>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { find, filter, first, orderBy, cloneDeep } from 'lodash'
import { DateTime } from 'luxon'
import { Italian } from 'flatpickr/dist/l10n/it.js'
import notificationType from '../../plugins/notification-field-name'

export default {
  name: 'Operation',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.updateLinks()
        this.getOperationFields()
        this.getOperationType()
        this.getOperationDone()
        this.getNotificationOptions()
      }
    })
  },
  data () {
    const vehicleId = this.$route.query.vehicle
    const genericDateConfig = {
      dateFormat: 'Y-m-d',
      mode: 'single',
      altFormat: 'D j M Y',
      altInput: true,
      locale: Italian,
      minDate: '',
      maxDate: '',
      disable: []
    }
    const config = this.$route.meta.config

    return {
      config,
      vehicleId,
      DateTime,
      find,
      operationOptions: [],
      disabledOptions: [],
      originalOperationItems: [],
      operationItems: [],
      vehiclesOption: [],
      companyOptions: [],
      recipientOptions: [],
      schedulingEvents: [],
      activitySectorOptions: [],
      ownerOptions: [],
      operationFields: [],
      operationType: [],
      operationDone: [],
      notificationOptions: [],
      insuranceCompanyOptions: [],
      disabledFilter: '',
      operationFilter: '',
      companyFilter: '',
      activitySectorFilter: '',
      ownerFilter: '',
      operationTypeFilter: '',
      doneFilter: '',
      vehicleFilter: '',
      notificationFilter: '',
      insuranceCompanyFilter: '',
      startFilter: null,
      endFilter: null,
      startFilterConfig: cloneDeep(genericDateConfig),
      endFilterConfig: cloneDeep(genericDateConfig),
      links: [
        '/configuration/company',
        '/configuration/operation',
        '/recipients',
        '/configuration/insurance_company'
      ],
      showCollapse: false,
      infoItem: {},
      isDeleteMode: false,
      kmStart: null,
      kmEnd: null
    }
  },
  watch: {
    clickedLink (link) {
      const vehicleId = this.vehicleFilter
      if (link.href === '/organization/registry_vehicles' && vehicleId) {
        this.$router.push({ name: 'EditVehicle', params: { id: vehicleId } })
      } else if (link.href && link.href !== '/organization/registry_vehicles') {
        this.$router.push(link.href)
      }
    },
    vehicleFilter (val) {
      this.operationItems = this.getItems(val, 'vehicleFilter')
      this.updateLinks(val)
    },
    disabledFilter (val) {
      this.operationItems = this.getItems(val, 'disabledFilter')
    },
    operationFilter (val) {
      this.operationItems = this.getItems(val, 'operationFilter')
    },
    companyFilter (val) {
      this.operationItems = this.getItems(val, 'companyFilter')
    },
    operationTypeFilter (val) {
      this.operationItems = this.getItems(val, 'operationTypeFilter')
    },
    doneFilter (val) {
      this.operationItems = this.getItems(val, 'doneFilter')
    },
    activitySectorFilter (val) {
      this.operationItems = this.getItems(val, 'activitySectorFilter')
    },
    ownerFilter (val) {
      this.operationItems = this.getItems(val, 'ownerFilter')
    },
    kmStart (val) {
      this.operationItems = this.getItems(val, 'kmStart')
    },
    kmEnd (val) {
      this.operationItems = this.getItems(val, 'kmEnd')
    },
    notificationFilter (val) {
      this.operationItems = this.getItems(val, 'notificationFilter')
    },
    insuranceCompanyFilter (val) {
      this.operationItems = this.getItems(val, 'insuranceCompanyFilter')
    }
  },
  methods: {
    clickedLink (link) {
      this.$router.push(link.href)
    },
    fetchData () {
      this.$root.$emit('activeLoader', true)
      this.getOptions().then(() => this.getOperations())
    },
    getOptions () {
      const axiosArray = []
      this.getOperationFields()
      this.getOperationType()
      this.getOperationDone()
      this.getNotificationOptions()
      this.getStatusOptions()
      axiosArray.push(this.getEnum('operation', 'operationOptions', true, true))
      axiosArray.push(this.getEnum('company', 'companyOptions', true))
      axiosArray.push(this.getEnum('activity_sector', 'activitySectorOptions', true))
      axiosArray.push(this.getEnum('owner', 'ownerOptions', true))
      axiosArray.push(this.getEnum('insurance_company', 'insuranceCompanyOptions', true))
      axiosArray.push(this.getRecipients())
      axiosArray.push(this.getVehicles())
      axiosArray.push(this.getSchedulingEvents())
      return Vue.myAll(axiosArray).then(r => r)
    },
    getOperationFields () {
      this.operationFields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '', hideInTable: !this.config.u && !this.config.r },
        { key: 'info', label: '', hideInTable: !this.config.u },
        { key: 'delete', label: '', hideInTable: !this.config.d },
        { key: 'text', label: this.$tc('message.vehicle', 1), sortable: true, sortDirection: 'desc' },
        { key: 'specialDesc', label: this.$tc('message.type', 1), sortable: true, sortDirection: 'desc' },
        { key: 'causalDesc', label: this.$t('message.causal'), sortable: true, sortDirection: 'desc' },
        { key: 'dateToShow', label: `${this.$tc('message.date', 1)}`, sortable: true, sortDirection: 'desc', isDate: true },
        { key: 'kmToShow', label: 'km', sortable: true, sortDirection: 'desc' },
        { key: 'eventActiveText', label: this.$tc('message.notification', 1), hideInTable: true },
        { key: 'description', label: this.$tc('message.note', 2), hideInTable: true },
        { key: 'executedText', label: this.$tc('message.done', 1), sortable: true, sortDirection: 'desc' }
      ]
    },
    getOperationType () {
      this.operationType = [
        { value: '', text: this.$t('message.selectOption') },
        { value: true, text: `${this.$t('message.ordinary')}` },
        { value: false, text: `${this.$t('message.extraOrdinary')}` }
      ]
    },
    getOperationDone () {
      this.operationDone = [
        { value: '', text: this.$t('message.all') },
        { value: true, text: `${this.$t('message.yes')}` },
        { value: false, text: `${this.$t('message.no')}` }
      ]
    },
    getNotificationOptions () {
      this.notificationOptions = [
        { value: '', text: this.$t('message.all') },
        { value: true, text: `${this.$tc('message.enabled', 2)}` },
        { value: false, text: `${this.$tc('message.disabled', 2)}` }
      ]
    },
    getStatusOptions () {
      this.disabledOptions = [
        { value: '', text: this.$tc('message.all', 1) },
        { value: false, text: this.$tc('message.enabled', 0) },
        { value: true, text: this.$tc('message.disabled', 0) }
      ]
    },
    getEnum (path, obj, selectionMessage, hasRecipients) {
      const options = []

      return Vue.myGet(this, `/enums/${path}`, 'data').then((items) => {
        if (selectionMessage) {
          options.push({ value: '', text: items.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption') })
        }
        items.forEach((item) => {
          if (hasRecipients) {
            options.push({
              value: item.id,
              text: item.descr,
              notificationRecipientId: item.notificationRecipientId,
              reminderRecipientId: item.reminderRecipientId
            })
          } else {
            options.push({ value: item.id, text: item.descr })
          }
        })
        if (obj) {
          this[obj] = options
        }
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getRecipients () {
      const editedRecipientOptions = [{ descr: this.$t('message.all'), value: '', recipients: [] }]
      return Vue.myGet(this, '/recipients_list', 'recipients').then((recipients) => {
        recipients.forEach(recipient => {
          editedRecipientOptions.push(recipient)
        })
        this.recipientOptions = editedRecipientOptions
        return editedRecipientOptions
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getVehicles () {
      const editedVehicleOptions = [{ text: this.$t('message.all'), value: '', enabled: true }]
      return Vue.myGet(this, '/vehicles?all=true', 'vehicles').then((vehicles) => {
        vehicles.forEach((vehicle) => {
          const brand = vehicle.type && vehicle.type.brand ? vehicle.type.brand : null
          const model = vehicle.type && vehicle.type.model ? vehicle.type.model : null
          const name = `${vehicle.plateNumber} ${brand ? '- ' + brand : ''} ${model ? '- ' + model : ''}`
          const insurances = {}

          if (vehicle.insurances) {
            vehicle.insurances.forEach(insurance => {
              insurances[insurance.company] = { start: insurance.startDate, end: insurance.endDate }
            })
          }

          const editedVehicleOption = {
            plateNumber: vehicle.plateNumber,
            value: vehicle.id,
            text: name,
            brand,
            model,
            registrationDate: vehicle.registrationDate,
            enabled: !vehicle.disablingDate,
            userCompany: vehicle.userCompany,
            activitySector: vehicle.activitySector,
            ownership: vehicle.ownership,
            insurances: insurances
          }
          editedVehicleOptions.push(editedVehicleOption)
        })
        this.vehiclesOption = editedVehicleOptions
        return editedVehicleOptions
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getSchedulingEvents () {
      this.schedulingEvents = []
      if (this.vehicleId === 'new') return true
      const srcEntity = 'srcEntity=operation'
      const url = `/scheduling?${srcEntity}`

      return Vue.myGet(this, url, 'events').then((events) => {
        const editedEvents = []
        events.forEach(event => {
          if (event.srcEntity === 'operation') {
            editedEvents.push(event)
          }
        })
        this.schedulingEvents = editedEvents
        return true
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getVehicleOption (e) {
      return `${e.text} ${e.enabled ? '' : this.$tc('message.disabled', 0)}`
    },
    getOperations () {
      Vue.myGet(this, '/operations', 'operations').then((operations) => {
        const events = cloneDeep(this.schedulingEvents)
        const editedOperations = []
        operations.forEach((operation) => {
          const editedOperation = operation
          const foundedVehicle = operation.vehicleId ? find(this.vehiclesOption, obj => obj.value === operation.vehicleId) : null
          const foundedOperationType = operation.type ? find(this.operationOptions, obj => obj.value === operation.type) : null
          const foundedNotificationGroup = foundedOperationType.notificationRecipientId
            ? find(this.recipientOptions, obj => obj.id === foundedOperationType.notificationRecipientId) : null
          const foundedReminderGroup = foundedOperationType.reminderRecipientId
            ? find(this.recipientOptions, obj => obj.id === foundedOperationType.reminderRecipientId) : null

          editedOperation.notificationGroup = foundedNotificationGroup ? foundedNotificationGroup.descr : this.$tc('message.emptyValue', 1)
          editedOperation.reminderGroup = foundedReminderGroup ? foundedReminderGroup.descr : this.$tc('message.emptyValue', 1)
          editedOperation.causalDesc = foundedOperationType ? foundedOperationType.text : null
          editedOperation.specialDesc = !operation.special ? this.$t('message.ordinary') : this.$t('message.extraOrdinary')
          if (operation.plannedDate) editedOperation.parsedPlannedDate = DateTime.fromSQL(operation.plannedDate).toFormat('dd-MM-y')
          operation.plannedKm ? editedOperation.plannedKm = parseInt(operation.plannedKm) : editedOperation.plannedKm = null
          if (operation.execDate) editedOperation.parsedExecDate = DateTime.fromSQL(operation.execDate).toFormat('dd-MM-y')
          operation.dateToShow = editedOperation.parsedExecDate || editedOperation.parsedPlannedDate
          operation.kmToShow = editedOperation.execKm || editedOperation.plannedKm
          if (foundedVehicle) {
            const insurances = foundedVehicle.insurances && Object.keys(foundedVehicle.insurances)
            const foundedCompany = foundedVehicle.userCompany ? find(this.companyOptions, obj => obj.value === foundedVehicle.userCompany) : null
            const foundedActivity = foundedVehicle.activitySector ? find(this.activitySectorOptions, obj => obj.value === foundedVehicle.activitySector) : null
            const foundedOwner = foundedVehicle && foundedVehicle.ownership && foundedVehicle.ownership.owner
              ? find(this.ownerOptions, obj => obj.value === foundedVehicle.ownership.owner && foundedVehicle.ownership.owner !== null) : null
            const foundedEvents = filter(events, obj => obj.srcFieldName === `${notificationType.OPERATION.TYPE}=${operation.type}` &&
              obj.srcObjectId === operation.vehicleId &&
              (operation.plannedDate && obj.date ? (operation.plannedDate === obj.date) : true) &&
              (operation.plannedkm && obj.km ? (operation.plannedkm === obj.km) : true)
            )
            const firstFondedEvent = foundedEvents && foundedEvents.length && foundedEvents.length !== 0 ? first(foundedEvents) : null

            if (insurances && insurances.length !== 0) {
              editedOperation.insurances = {}
              insurances.forEach(insurance => {
                editedOperation.insurances[insurance] = foundedVehicle.insurances[insurance]
              })
            }

            editedOperation.plateNumber = foundedVehicle.plateNumber
            editedOperation.text = foundedVehicle.text
            editedOperation.model = foundedVehicle.model
            editedOperation.brand = foundedVehicle.brand
            editedOperation.vehicleDisabled = !foundedVehicle.enabled
            editedOperation.userCompany = foundedCompany ? foundedCompany.value : null
            editedOperation.userCompanyText = foundedCompany ? foundedCompany.text : null
            editedOperation.activitySector = foundedActivity ? foundedActivity.value : null
            editedOperation.activitySectorText = foundedActivity ? foundedActivity.text : null
            editedOperation.owner = foundedOwner ? foundedOwner.value : null
            editedOperation.ownerText = foundedOwner ? foundedOwner.text : null
            editedOperation.eventActiveText = firstFondedEvent && firstFondedEvent.active ? this.$tc('message.enabled', 3) : this.$tc('message.disabled', 0)
            editedOperation.eventActiveVal = (firstFondedEvent && firstFondedEvent.active) || null
            editedOperation.eventId = (firstFondedEvent && firstFondedEvent.id) || null
          }
          editedOperation.executedText = editedOperation.executed ? this.$t('message.yes') : this.$t('message.no')
          editedOperations.push(editedOperation)
        })
        this.originalOperationItems = orderBy(editedOperations, 'text')
        this.operationItems = cloneDeep(this.originalOperationItems)
        if (this.vehicleId) {
          this.vehicleFilter = this.vehicleId
        }
        this.$root.$emit('activeLoader', false)
        this.updateLinks()
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        this.updateLinks()
      })
    },
    getItems (val, field) {
      const vehicle = field === 'vehicleFilter' ? val : this.vehicleFilter
      const status = field === 'disabledFilter' ? val : this.disabledFilter
      const operation = field === 'operationFilter' ? val : this.operationFilter
      const company = field === 'companyFilter' ? val : this.companyFilter
      const type = field === 'operationTypeFilter' ? val : this.operationTypeFilter
      const done = field === 'doneFilter' ? val : this.doneFilter
      const sector = field === 'activitySectorFilter' ? val : this.activitySectorFilter
      const owner = field === 'ownerFilter' ? val : this.ownerFilter
      const dateStart = field === 'startFilter' ? val : this.startFilter
      const dateEnd = field === 'endFilter' ? val : this.endFilter
      const kmStart = field === 'kmStart' ? val : this.kmStart
      const kmEnd = field === 'kmEnd' ? val : this.kmEnd
      const notification = field === 'notificationFilter' ? val : this.notificationFilter
      const insuranceCompany = field === 'insuranceCompanyFilter' ? val : this.insuranceCompanyFilter

      let editedItems = cloneDeep(this.originalOperationItems)
      if (vehicle && vehicle !== '') {
        editedItems = filter(editedItems, obj => obj.vehicleId === vehicle)
      }
      if (status !== null && status !== '') {
        editedItems = filter(editedItems, obj => {
          return obj.vehicleDisabled === status
        })
      }
      if (operation && operation !== '') {
        editedItems = filter(editedItems, obj => obj.type === operation)
      }
      if (company && company !== '') {
        editedItems = filter(editedItems, obj => obj.userCompany === company)
      }
      if (sector && sector !== '') {
        editedItems = filter(editedItems, obj => obj.activitySector === sector)
      }
      if (owner && owner !== '') {
        editedItems = filter(editedItems, obj => obj.owner === owner)
      }
      if (type !== null && type !== '') {
        editedItems = filter(editedItems, obj => obj.special !== type)
      }
      if (done !== null && done !== '') {
        editedItems = filter(editedItems, obj => obj.executed === done)
      }
      if (dateStart) {
        editedItems = filter(editedItems, obj => (obj.plannedDate
          ? DateTime.fromSQL(obj.plannedDate) >= DateTime.fromSQL(dateStart) : false) ||
          (obj.execDate ? DateTime.fromSQL(obj.execDate) >= DateTime.fromSQL(dateStart) : false))
      }
      if (dateEnd) {
        editedItems = filter(editedItems, obj => (obj.plannedDate
          ? DateTime.fromSQL(obj.plannedDate) <= DateTime.fromSQL(dateEnd) : false) ||
          (obj.execDate ? DateTime.fromSQL(obj.execDate) <= DateTime.fromSQL(dateEnd) : false))
      }
      if (kmStart) {
        editedItems = filter(editedItems, obj => (obj.plannedKm
          ? parseInt(obj.plannedKm) >= parseInt(kmStart) : false) ||
          (obj.execKm ? parseInt(obj.execKm) >= parseInt(kmStart) : false)
        )
      }
      if (kmEnd) {
        editedItems = filter(editedItems, obj => (obj.plannedKm
          ? parseInt(obj.plannedKm) <= parseInt(kmEnd) : false) ||
          (obj.execKm ? parseInt(obj.execKm) <= parseInt(kmStart) : false)
        )
      }
      if (notification && notification !== '') {
        editedItems = filter(editedItems, obj => obj.eventActiveVal === notification)
      }
      if (insuranceCompany && insuranceCompany !== '') {
        editedItems = filter(editedItems, obj => {
          if (obj.insurances && obj.insurances[insuranceCompany]) {
            if (!obj.plannedDate && !obj.execDate) return false

            const start = DateTime.fromSQL(obj.insurances[insuranceCompany].start)
            const end = DateTime.fromSQL(obj.insurances[insuranceCompany].end)
            const plannedDate = DateTime.fromSQL(obj.plannedDate)
            const execDate = DateTime.fromSQL(obj.execDate)

            return (plannedDate >= start && plannedDate <= end) || (execDate >= start && execDate <= end)
          }
          return false
        })
      }
      return editedItems
    },
    getExcelFields () {
      return [
        { key: 'plateNumber', label: this.$tc('message.numberPlate', 1) },
        { key: 'brand', label: this.$t('message.brand') },
        { key: 'model', label: this.$tc('message.model', 1) },
        { key: 'userCompanyText', label: this.$t('message.userCompany') },
        { key: 'activitySectorText', label: `${this.$tc('message.sector', 1)} ${this.$tc('message.activity', 1).toLowerCase()}` },
        { key: 'ownerText', label: this.$tc('message.property', 1) },
        { key: 'specialDesc', label: this.$tc('message.type', 1), sortable: true, sortDirection: 'desc' },
        { key: 'causalDesc', label: this.$t('message.causal'), sortable: true, sortDirection: 'desc' },
        { key: 'parsedPlannedDate', label: `${this.$tc('message.date', 1)}`, sortable: true, sortDirection: 'desc', isDate: true },
        { key: 'plannedKm', label: 'km', sortable: true, sortDirection: 'desc' },
        { key: 'notificationGroup', label: this.$t('message.notificationGroup'), sortable: true, sortDirection: 'desc' },
        { key: 'reminderGroup', label: this.$t('message.reminderGroup'), sortable: true, sortDirection: 'desc' },
        { key: 'eventActiveText', label: this.$tc('message.notification', 1), sortable: true, sortDirection: 'desc' },
        { key: 'executedText', label: this.$tc('message.done', 1), sortable: true, sortDirection: 'desc' },
        { key: 'execKm', label: `km ${this.$tc('message.operation', 1).toLowerCase()} ${this.$tc('message.done', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'parsedExecDate', label: `${this.$tc('message.date', 1)} ${this.$tc('message.operation', 1).toLowerCase()} ${this.$tc('message.done', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'description', label: this.$tc('message.note', 2), hideInTable: true }
      ]
    },
    pushToEdit (item) {
      item && item.id ? this.$router.push({
        name: 'EditOperation', params: { id: item.id }, query: { vehicle: item.vehicleId }
      }) : (this.vehicleFilter && this.vehicleFilter !== ''
        ? this.$router.push({ name: 'EditOperation', params: { id: 'new' }, query: { vehicle: this.vehicleFilter } })
        : this.$router.push({ name: 'EditOperation', params: { id: 'new' } }))
    },
    showInfo (item, deleteMode) {
      this.isDeleteMode = deleteMode
      this.infoItem = item
      this.$refs.infoModal.show()
    },
    resetFilters () {
      this.vehicleFilter = ''
      this.disabledFilter = ''
      this.operationFilter = ''
      this.companyFilter = ''
      this.operationTypeFilter = ''
      this.activitySectorFilter = ''
      this.doneFilter = ''
      this.ownerFilter = ''
      this.notificationFilter = ''
      this.insuranceCompanyFilter = ''
      this.startFilter = null
      this.endFilter = null
      this.kmStart = null
      this.kmEnd = null
      this.$refs.operationTable.resetSearch()
    },
    closeInfoModal () {
      this.$refs.infoModal.hide()
      this.infoItem = {}
    },
    checkSchedulingDelete (item) {
      if (item.eventId) {
        Vue.myDelete(this, `/scheduling/${item.eventId}`).then(() => {
          this.deleteOperation(item.id)
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        })
      } else {
        this.deleteOperation(item.id)
      }
    },
    deleteOperation (id) {
      Vue.myDelete(this, `/operations/${id}`).then(() => {
        Vue.success(this, `${this.$tc('message.delete')} ${this.$tc('message.done', 2).toLowerCase()}`)
        this.$router.push({ name: 'RefreshPage', params: { name: 'Operation' } })
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
      })
    },
    updateLinks (vehicle) {
      const links = vehicle && vehicle !== '' ? [{ href: '/organization/registry_vehicles' }] : []
      this.links.forEach(link => {
        links.push({ href: link })
      })
      this.$root.$emit('change-links', links)
    },
    startFilterChanged (val) {
      this.updateDateConfig(val, this.endFilter)
    },
    endFilterChanged (val) {
      this.updateDateConfig(this.startFilter, val)
    },
    updateDateConfig (start, end) {
      let editedStart = start
      let editedEnd = end
      if (start && first(start) && DateTime.fromJSDate(first(start)).isValid) {
        editedStart = DateTime.fromJSDate(first(start)).toSQLDate()
      } else if (start && first(start) && DateTime.fromHTTP(first(start)).isValid) {
        editedStart = DateTime.fromHTTP(first(start)).toSQLDate()
      }
      if (end && first(end) && DateTime.fromJSDate(first(end)).isValid) {
        editedEnd = DateTime.fromJSDate(first(end)).toSQLDate()
      } else if (end && first(end) && DateTime.fromHTTP(first(end)).isValid) {
        editedEnd = DateTime.fromHTTP(first(end)).toSQLDate()
      }

      this.startFilterConfig.maxDate = editedEnd ? DateTime.fromSQL(editedEnd).toSQLDate() : null
      this.startFilterConfig.minDate = editedEnd ? DateTime.fromSQL(editedEnd).plus({ month: -6 }).toSQLDate() : null
      this.endFilterConfig.minDate = editedStart ? DateTime.fromSQL(editedStart).toSQLDate() : null
      this.endFilterConfig.maxDate = editedStart ? DateTime.fromSQL(editedStart).plus({ month: 6 }).toSQLDate() : null

      if ((editedStart && editedStart.length && editedStart.length === 0) || !DateTime.fromSQL(editedStart).isValid) editedStart = null
      if ((editedEnd && editedEnd.length && editedEnd.length === 0) || !DateTime.fromSQL(editedEnd).isValid) editedEnd = null
      this.operationItems = this.updateByDateAndKm(this.getItems(), editedStart, editedEnd)
    },
    updateByDateAndKm (items, dateStart, dateEnd) {
      let editedItems = cloneDeep(items)

      if (dateStart) {
        editedItems = filter(editedItems, obj => (obj.plannedDate
          ? DateTime.fromSQL(obj.plannedDate) >= DateTime.fromSQL(dateStart) : false) ||
          (obj.execDate ? DateTime.fromSQL(obj.execDate) >= DateTime.fromSQL(dateStart) : false))
      }
      if (dateEnd) {
        editedItems = filter(editedItems, obj => (obj.plannedDate
          ? DateTime.fromSQL(obj.plannedDate) <= DateTime.fromSQL(dateEnd) : false) ||
          (obj.execDate ? DateTime.fromSQL(obj.execDate) <= DateTime.fromSQL(dateEnd) : false))
      }
      return editedItems
    }
  }
}
</script>
